import React, { useMemo, useEffect } from 'react';
import { styled, DateTimePicker, SubTitle, Body } from '@teko/ds-desktop';
import { t } from '../../i18n.es.js';

const TimeSlotSelect = styled.div`
  display: flex;
  flex-flow: wrap;
  margin: 0 -0.25rem;
  padding-bottom: 0.25rem;

  > * {
    margin: 0 0.25rem 0.5rem;
  }
`;
const TimeSlotOptionDiv = styled.div(({
  theme,
  highlighted,
  disabled
}) => `
  min-width: 5.75rem;
  padding: 0.625rem 0.375rem;
  border: 1px solid ${highlighted ? theme == null ? void 0 : theme.colors.primary500 : theme == null ? void 0 : theme.colors.disable};
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  text-align: center;
  background-color: ${disabled ? "#DCDEE9" : "none"};
`);
const TimeSlotOption = ({
  from,
  to,
  highlighted = false,
  disabled = false,
  onClick = () => {
  }
}) => {
  return /* @__PURE__ */ React.createElement(TimeSlotOptionDiv, {
    highlighted,
    onClick,
    disabled
  }, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: highlighted ? "primary500" : "textPrimary"
  }, `${from} - ${to}`));
};
const StyledDatetimePicker = styled(DateTimePicker)`
  margin-bottom: 0.75rem;
  width: 12rem;

  input {
    background-color: transparent;
  }
`;
const DeliveryDatetimePicker = ({
  selectedTimeSlot,
  timeSlots = [],
  hideTitle = false,
  selectedDate,
  enableDates,
  onChange = () => {
  }
}) => {
  const newSelectedTimeSlot = useMemo(() => {
    if (selectedTimeSlot)
      return timeSlots.find((timeSlot) => timeSlot.from === selectedTimeSlot.from && timeSlot.to === selectedTimeSlot.to);
    return selectedTimeSlot;
  }, [timeSlots, selectedTimeSlot]);
  useEffect(() => {
    if (!!(newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.disabled) && (selectedTimeSlot == null ? void 0 : selectedTimeSlot.disabled) !== newSelectedTimeSlot.disabled) {
      onChange(selectedDate, void 0);
    }
  }, [newSelectedTimeSlot]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !hideTitle && /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4
  }, t("Ch\u1ECDn ng\xE0y nh\u1EADn h\xE0ng")), /* @__PURE__ */ React.createElement(StyledDatetimePicker, {
    id: "selected-date-picker",
    value: selectedDate,
    onChange: (val) => {
      onChange(val || void 0, newSelectedTimeSlot);
    },
    disabledDate: (date) => !(enableDates == null ? void 0 : enableDates.some((val) => date.getDate() === val.getDate() && date.getMonth() === val.getMonth() && date.getFullYear() === val.getFullYear()))
  }), !!(timeSlots == null ? void 0 : timeSlots.length) && /* @__PURE__ */ React.createElement(React.Fragment, null, !hideTitle && /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4
  }, t("Ch\u1ECDn khung gi\u1EDD")), /* @__PURE__ */ React.createElement(TimeSlotSelect, {
    id: "selected-time-picker"
  }, timeSlots.map((timeSlot, i) => {
    const highlight = (timeSlot == null ? void 0 : timeSlot.from) === (newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.from) && (timeSlot == null ? void 0 : timeSlot.to) === (newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.to) && !(newSelectedTimeSlot == null ? void 0 : newSelectedTimeSlot.disabled);
    return /* @__PURE__ */ React.createElement(TimeSlotOption, {
      key: i,
      from: timeSlot.from,
      to: timeSlot.to,
      highlighted: highlight,
      disabled: timeSlot.disabled,
      onClick: () => {
        if (!timeSlot.disabled)
          onChange(selectedDate, highlight ? {
            from: void 0,
            to: void 0
          } : timeSlot);
      }
    });
  }))));
};

export { DeliveryDatetimePicker };
